import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import { Cadastro } from './signup';
import { Login } from './login'
import { AuthRoute, UnAuthRoute } from '../components'
import { Home } from './home';
import { MyBids } from './my-bids';
import { NewBid } from './my-bids/new';
import { Bids } from './bids';
import { SelectBidAccount } from './my-bids/account-select';
import { Profile } from './profile';
import { Cards } from './cards';
import { NewCard } from './cards/new';
import { NewAccount } from './accounts/new';
import { Orders } from './orders';
import { NewOrder } from './bids/order';
import { Payments } from './payments';
import { Payment } from './payments/id';
import { MyPayments } from './my-payments';
import { MyAccounts } from './accounts';
import { Account } from './accounts/id';
import { Users } from './users';
import { User } from './users/id';
import { Order } from './orders/id';
import { Bid } from './bids/id';
import { Programs } from './programs';
import { Welcome } from './welcome';
import { ForgotPassword } from './forgot-password';
import { NewPassword } from './new-password';
import { MyBid } from './my-bids/id';
import { Dashboard } from './dashboard';
import { CreateOrder } from './orders/new';
import { Help } from './help';
import { NewHelp } from './help/new';
import { HelpId } from './help/id';
import { SupportTickets } from './support-tickets';
import { SupportTicket } from './support-tickets/id';
import { CardId } from './cards/id';
import { Banking } from './banking';

export const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <UnAuthRoute>
            <Login />
        </UnAuthRoute>
      ),
    },
    {
      path: "/esqueci-minha-senha",
      element: (
        <UnAuthRoute>
            <ForgotPassword />
        </UnAuthRoute>
      ),
    },
    {
      path: "/nova-senha",
      element: (
        <UnAuthRoute>
            <NewPassword />
        </UnAuthRoute>
      ),
    },
    {
        path: '/cadastro',
        element: (
            <UnAuthRoute>
                <Cadastro />
            </UnAuthRoute>
          ),
    },
    {
        path: '/home',
        element: (
            <AuthRoute>
                <Home />
            </AuthRoute>
        )
    },
    {
        path: '/minhas-ofertas',
        element: (
            <AuthRoute>
                <MyBids />
            </AuthRoute>
        )
    },
    {
        path: '/minhas-ofertas/nova',
        element: (
            <AuthRoute>
                <NewBid />
            </AuthRoute>
        )
    },
    {
        path: '/ofertas',
        element: (
            <AuthRoute>
                <Bids />
            </AuthRoute>
        )
    },
    {
        path: '/minhas-ofertas/:id/selecionar-conta',
        element: (
            <AuthRoute>
                <SelectBidAccount />
            </AuthRoute>
        )
    },
    {
        path: '/minhas-ofertas/:id',
        element: (
            <AuthRoute>
                <MyBid />
            </AuthRoute>
        )
    },
    {
        path: '/meu-perfil',
        element: (
            <AuthRoute>
                <Profile />
            </AuthRoute>
        )
    },
    {
        path: '/cartoes',
        element: (
            <AuthRoute>
                <Cards />
            </AuthRoute>
        )
    },
    {
        path: '/cartoes/novo',
        element: (
            <AuthRoute>
                <NewCard />
            </AuthRoute>
        )
    },
    {
        path: '/cartoes/:id',
        element: (
            <AuthRoute>
                <CardId />
            </AuthRoute>
        )
    },
    {
        path: '/contas/nova',
        element: (
            <AuthRoute>
                <NewAccount />
            </AuthRoute>
        )
    },
    {
        path: '/emissoes',
        element: (
            <AuthRoute>
                <Orders />
            </AuthRoute>
        )
    },
    {
        path: '/dashboard',
        element: (
            <AuthRoute>
                <Dashboard />
            </AuthRoute>
        )
    },
    {
        path: '/ofertas/:id/emissao',
        element: (
            <AuthRoute>
                <NewOrder />
            </AuthRoute>
        )
    },
    {
        path: '/pagamentos',
        element: (
            <AuthRoute>
                <Payments />
            </AuthRoute>
        )
    },
    {
        path: '/pagamentos/:id',
        element: (
            <AuthRoute>
                <Payment />
            </AuthRoute>
        )
    },
    {
        path: '/meus-pagamentos',
        element: (
            <AuthRoute>
                <MyPayments />
            </AuthRoute>
        )
    },
    {
        path: '/minhas-contas',
        element: (
            <AuthRoute>
                <MyAccounts />
            </AuthRoute>
        )
    },
    {
        path: '/minhas-contas/:id',
        element: (
            <AuthRoute>
                <Account />
            </AuthRoute>
        )
    },
    {
        path: '/usuarios',
        element: (
            <AuthRoute>
                <Users />
            </AuthRoute>
        )
    },
    {
        path: '/usuarios/:id',
        element: (
            <AuthRoute>
                <User />
            </AuthRoute>
        )
    },
    {
        path: '/emissoes/nova',
        element: (
            <AuthRoute>
                <CreateOrder />
            </AuthRoute>
        )
    },
    {
        path: '/emissoes/:id',
        element: (
            <AuthRoute>
                <Order />
            </AuthRoute>
        )
    },
    {
        path: '/ofertas/:id',
        element: (
            <AuthRoute>
                <Bid />
            </AuthRoute>
        )
    },
    {
        path: '/financeiro',
        element: (
            <AuthRoute>
                <Banking />
            </AuthRoute>
        )
    },
    {
        path: '/programas',
        element: (
            <AuthRoute>
                <Programs />
            </AuthRoute>
        )
    },
    {
        path: '/bem-vindo',
        element: (
            <AuthRoute>
                <Welcome />
            </AuthRoute>
        )
    },
    {
        path: '/ajuda',
        element: (
            <AuthRoute>
                <Help />
            </AuthRoute>
        )
    },
    {
        path: '/ajuda/novo',
        element: (
            <AuthRoute>
                <NewHelp />
            </AuthRoute>
        )
    },
    {
        path: '/ajuda/:id',
        element: (
            <AuthRoute>
                <HelpId />
            </AuthRoute>
        )
    },
    {
        path: '/chamados',
        element: (
            <AuthRoute>
                <SupportTickets />
            </AuthRoute>
        )
    },
    {
        path: '/chamados/:id',
        element: (
            <AuthRoute>
                <SupportTicket />
            </AuthRoute>
        )
    }
]);
  

const Provider = () => {
    return (
        <RouterProvider router={router} />
    )
}

export default Provider